import { render, staticRenderFns } from "./commodity-info.vue?vue&type=template&id=571a5aae&scoped=true"
import script from "./commodity-info.vue?vue&type=script&lang=js"
export * from "./commodity-info.vue?vue&type=script&lang=js"
import style0 from "./commodity-info.vue?vue&type=style&index=0&id=571a5aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571a5aae",
  null
  
)

export default component.exports